import { useReactiveVar } from "@apollo/client";
import { mdiLock } from "@mdi/js";
import Icon from "@mdi/react";
import React, { useContext } from "react";
import TeamLogo from "src/components/Team/TeamLogo";
import { currentSport } from "src/services/ApolloService";
import { SubscriptionContext } from "src/services/SubscriptionService";
import styles from "./styles.scss";
import { calculateRecords } from "../ScheduleList";

const ScheduleSummary = ({ event }: { event: any }) => {
  const { awayTeam, homeTeam, freeGame } = event;

  const isNotPreseasonGame = (game: any) => game.seasonType !== "PRESEASON";
  const homeSchedule = homeTeam.schedule?.filter(isNotPreseasonGame);
  const awaySchedule = awayTeam.schedule?.filter(isNotPreseasonGame);

  const homeRecords = calculateRecords({ schedule: homeSchedule, team: homeTeam });
  const awayRecords = calculateRecords({ schedule: awaySchedule, team: awayTeam });

  const teamDatas = [
    {
      title: "Games Played",
      homeTeam: homeRecords.numOfPlayedGames,
      awayTeam: awayRecords.numOfPlayedGames,
    },
    {
      title: "Record",
      homeTeam: homeRecords.record,
      awayTeam: awayRecords.record,
    },
    {
      title: "ATS Record",
      homeTeam: homeRecords.atsRecord,
      awayTeam: awayRecords.atsRecord,
    },
    {
      title: "Cover  %",
      homeTeam: homeRecords.atsCover,
      awayTeam: awayRecords.atsCover,
    },
    {
      title: "O/U Record",
      homeTeam: homeRecords.ouRecord,
      awayTeam: awayRecords.ouRecord,
    },
    {
      title: "Over  %",
      homeTeam: homeRecords.ouCover,
      awayTeam: awayRecords.ouCover,
    },
  ];

  const currentSportObj = useReactiveVar(currentSport);
  const leagueKey = currentSportObj?.key || "";
  const teamLogo = currentSportObj?.imagePath || "";
  const ctx = useContext(SubscriptionContext);
  const hasAccess = freeGame || ctx.hasSubscriptionAccess(leagueKey);

  return (
    <div className="schedule-summary__container">
      <div className="schedule-summary__title">Schedule Summary</div>
      <div className="schedule-summary__table-container">
        <div className="schedule-summary__row">
          <div className="schedule-summary__stat-data">
            <div className="schedule-summary__team-info-container">
              <TeamLogo
                containerClassName="schedule-summary__logo-container"
                className="schedule-summary__logo"
                leagueName={teamLogo}
                size={64}
                teamAbbreviation={awayTeam.preferredAbbreviation}
              />
            </div>
          </div>

          <div className="schedule-summary__stat-title" />
          <div className="schedule-summary__stat-data">
            <div className="schedule-summary__team-info-container">
              <TeamLogo
                containerClassName="schedule-summary__logo-container"
                className="schedule-summary__logo"
                leagueName={teamLogo}
                size={64}
                teamAbbreviation={homeTeam.preferredAbbreviation}
              />
            </div>
          </div>
        </div>

        <div className="schedule-summary__row">
          <div className="schedule-summary__stat-data">{awayTeam.preferredAbbreviation}</div>
          <div className="schedule-summary__stat-title">Teams</div>
          <div className="schedule-summary__stat-data">{homeTeam.preferredAbbreviation}</div>
        </div>

        {teamDatas.map((item: any, index: number) => {
          return (
            <div className="schedule-summary__row" key={index}>
              <div className="schedule-summary__stat-data">
                <span>{hasAccess ? item.awayTeam : <Icon path={mdiLock} size="16px" color="#8a8a8a" />}</span>
              </div>
              <div className="schedule-summary__stat-title">
                <span>{item.title}</span>
              </div>
              <div className="schedule-summary__stat-data">
                <span>{hasAccess ? item.homeTeam : <Icon path={mdiLock} size="16px" color="#8a8a8a" />}</span>
              </div>
            </div>
          );
        })}
      </div>
      <style jsx global>
        {styles}
      </style>
    </div>
  );
};

export default ScheduleSummary;
